/**
 * Locally GTM Events
 */
window.addEventListener('click', event => {
    const showAllLocalOptions = document.querySelector('[href="https://www.locally.com/brand/nemo"]')
    const specificLocationOptions = [...document.querySelectorAll('[data-switchlive-store-id]')]
    const path = event.composedPath()

    // TAG: Find It Local - All
    if (path.includes(showAllLocalOptions)) {
        window.dataLayer.push({
            event: 'find-local-all'
        })
    }

    // TAG: Find Local Location
    if (specificLocationOptions.some(locationOption => path.includes(locationOption))) {
        window.dataLayer.push({
            event: 'find-local-location'
        })
    }
})
